const api = {
	storeCountByStatus: '/store/storeCountByStatus', // 查询域空间下个状态店铺数量
	listStoresByStatus: '/store/listStoresByStatus', // 查询域空间下店铺列表
	deleteStore: '/store/deleteStore', // 删除店铺接口
	closeStore: '/store/closeStore', // 关闭店铺
	openStore: '/store/openStore', // 开启店铺
	handleStoreApplication: '/store/handleStoreApplication', // 店铺审核接口
	detail: '/store/detail', // 查询店铺详情
	auditDetail: '/store/opAuditDetail',  // 店铺审核状态
	batchImportStores: '/store/batchImportStores', // 批量导入店铺
	configStore: '/store/configStore', // 配置店铺
	getAllCommunitiesByNamespaceId: '/openapi/getAllCommunitiesByNamespaceId', //evh 获取某个域空间下的所有项目

	// --- 商城 ---
	listMallStoresByStatus: '/mall/listMallStoresByStatus', // 查询商城下店铺列表
	deleteMallStore: '/mall/deleteStore', // 商城删除店铺接口
	closeMallStore: '/mall/closeStore', // 商城关闭店铺
	openMallStore: '/mall/openStore', // 商城开启店铺
	handleApplicationByMall: '/mall/handleApplicationByMall', // 商城审核接口
	sendVerificationCode: '/message/sendVerificationCode', // 发送验证码
	adminChangeStoreSuperAdministrator: '/mall/adminChangeStoreSuperAdministrator', // 更换负责人
};

const routes = {
	'/shop-approve': '店铺管理',
	'/shop-approve/detail': '店铺详情',
};

export { api, routes };
